import { render } from "./Design.vue?vue&type=template&id=214f88f1"
import script from "./Design.vue?vue&type=script&lang=js"
export * from "./Design.vue?vue&type=script&lang=js"

import "./Design.vue?vue&type=style&index=0&id=214f88f1&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.27.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__